// src/config.js
const BASE_URL = "https://cms.shikshainitiative.org";

export default BASE_URL;
